export const buildKLSourceCitationId = (sourceId: string) => `kls-${sourceId}`

export const isKLSourceCitationId = (id: string) => id.startsWith('kls-')

export const parseKLSourceCitationSourceId = (id: string) => id.replace('kls-', '')